import dayjs from 'dayjs';
import eData from './economyData';
import pData from './prefixData';
import rData from './regionData';
import aData from './asnData';

function updateDate(dataArray) {
  const today = dayjs();
  const newData = [];
  for (let i = dataArray.length - 1; i >= 0; i--) {
    newData.push({
      ...dataArray[i],
      date: today.subtract(dataArray.length - 1 - i, 'day').format('YYYY-MM-DD')
    });
  }
  return newData;
}

const economyData = updateDate(eData);
const regionData = updateDate(rData);
const asnData = updateDate(aData);
const prefixData = updateDate(pData);

export default {
  accountList: [
    {
      id: '9999',
      account: 'Example',
      opaqueId: 'A9000000',
      opaqueUrl: '/Orgid/A9000000',
      economy: 'VN',
      economyName: 'Vietnam',
      economyUrl: '/CC/VN',
      economyData: { id: 'VN', data: economyData },
      region: '035 South-Eastern Asia',
      regionUrl: '/Region/035%20South-Eastern%20Asia',
      regionData: {
        id: '035 South-Eastern Asia',
        data: regionData
      },
      ASNs: [
        {
          asn: 'Example AS',
          longName: 'Example AS ',
          id: '65536',
          url: '/AS/AS65536',
          prefixUrl: '/PFX/AS65536',
          data: {
            id: '65536',
            data: asnData
          },
          prefix: {
            data: prefixData
          }
        }
      ]
    }
  ],
  asnList: [
    {
      asn: 'Example AS',
      longName: 'Example AS ',
      id: '65536',
      url: '/AS/AS65536',
      prefixUrl: '/PFX/AS65536',
      data: {
        id: '65536',
        data: asnData
      },
      prefix: {
        data: prefixData
      }
    }
  ],
  economyData: [
    {
      id: 'VN',
      data: economyData
    }
  ],
  regionData: [
    {
      id: '035 South-Eastern Asia',
      data: regionData
    }
  ],
  selectedAccount: {
    id: '9999',
    account: 'Example',
    opaqueId: 'A9000000',
    opaqueUrl: '/Orgid/A9000000',
    economy: 'VN',
    economyName: 'Vietnam',
    economyUrl: '/CC/VN',
    economyData: {
      id: 'VN',
      data: economyData
    },
    region: '035 South-Eastern Asia',
    regionUrl: '/Region/035%20South-Eastern%20Asia',
    regionData: {
      id: '035 South-Eastern Asia',
      data: regionData
    },
    ASNs: [
      {
        asn: 'Example AS',
        longName: 'Example AS ',
        id: '65536',
        url: '/AS/AS65536',
        prefixUrl: '/PFX/AS65536',
        data: {
          id: '65536',
          data: asnData
        },
        prefix: {
          data: prefixData
        }
      }
    ]
  },
  selectedASN: {
    asn: 'Example AS',
    longName: 'Example AS ',
    id: '65536',
    url: '/AS/AS65536',
    prefixUrl: '/PFX/AS65536',
    data: {
      id: '65536',
      data: asnData
    },
    prefix: {
      data: prefixData
    }
  }
};
